/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesMoreNews = require('redux/modules/moreNews');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPagify = require('react-pagify');

var _reactPagify2 = _interopRequireDefault(_reactPagify);

var _segmentize = require('segmentize');

var _segmentize2 = _interopRequireDefault(_segmentize);

var _components = require('components');

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesMoreNews.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesMoreNews.load(20, 1)));
	}

	return _Promise.all(promises);
}

var MoreNews = (function (_Component) {
	_inherits(MoreNews, _Component);

	function MoreNews() {
		var _this = this;

		_classCallCheck(this, _MoreNews);

		_Component.apply(this, arguments);

		this.state = {
			currentPage: 1,
			pageOffset: 0,
			perPage: 20,
			showSidebar: false,
			isSmallViewport: false,
			isMediumViewport: false,
			isLargeViewport: false,
			mostPopularIsStuck: false,
			mostPopularIsStuckToBottom: false
		};

		this.handleSearch = function (page) {
			var dispatch = _this.context.store.dispatch;
			var _state = _this.state;
			var pageOffset = _state.pageOffset;
			var perPage = _state.perPage;

			dispatch(_reduxModulesMoreNews.load(perPage, pageOffset + (page - 1)));
		};
	}

	MoreNews.prototype.render = function render() {
		var _this2 = this;

		var styles = require('./MoreNews.css');

		// Show loading spinner while article is fetched
		if (this.props.articlesLoading || this.props.articlesLoading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var articles = this.props.articles;

		var theArticles = _lodash2['default'].map(articles.results, function (article) {
			var _classNames;

			var headerClasses = _classnames2['default']((_classNames = {}, _classNames[styles.ArticleHeader] = true, _classNames[styles['ArticleHeader--withImage']] = article.images && article.images['bbrew-small'], _classNames));

			return _react2['default'].createElement(
				'div',
				{ key: article.id },
				_react2['default'].createElement(
					'article',
					{ className: styles.Article },
					article.images && article.images['bbrew-small'] && _react2['default'].createElement(
						'figure',
						{ className: styles.ArticleFigure },
						_react2['default'].createElement(
							_reactRouter.Link,
							{ to: article.url },
							_react2['default'].createElement('img', { src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
						)
					),
					_react2['default'].createElement(
						'header',
						{ className: headerClasses },
						_react2['default'].createElement(_components.MetaBar, {
							author: article.author.name,
							authorURI: article.author.slug,
							categories: article.categories,
							postDate: article.date }),
						_react2['default'].createElement(
							_reactRouter.Link,
							{ to: article.url },
							_react2['default'].createElement(
								'h1',
								{ className: styles.ArticleTitle },
								article.title
							),
							_this2.state.isSmallViewport && _react2['default'].createElement(
								'figure',
								{ className: styles.ArticleFigure },
								_react2['default'].createElement('img', { className: styles.FigureImage, src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
							)
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'More News | Baltimore Brew' }),
			_react2['default'].createElement(
				'section',
				{ className: styles.Results },
				_react2['default'].createElement(
					'header',
					{ className: styles.SectionHeader },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						'More News'
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Articles },
					theArticles
				),
				_react2['default'].createElement(
					'footer',
					{ className: styles.SectionFooter },
					_react2['default'].createElement(
						_reactPagify2['default'].Context,
						{ className: styles.Pagination,
							tags: {
								container: {
									tag: 'ul'
								},
								segment: {
									tag: 'li',
									props: {
										className: styles.PaginationLinks
									}
								},
								ellipsis: {
									tag: 'li'
								}
							},
							segments: _segmentize2['default']({
								beginPages: 1,
								endPages: 1,
								page: articles.page,
								pages: articles.totalPages,
								sidePages: 2
							}), onSelect: function (page) {
								return _this2.handleSearch(page);
							} },
						_react2['default'].createElement(
							_reactPagify2['default'].Button,
							{ className: styles['PaginationLinks--previous'], page: articles.page - 1 },
							'«'
						),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'beginPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Ellipsis, { className: styles.PaginationEllipsis, previousField: 'beginPages', nextField: 'previousPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'previousPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'centerPage', className: styles['PaginationLinks--isActive'] }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'nextPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Ellipsis, { className: styles.PaginationEllipsis, previousField: 'nextPages', nextField: 'endPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'endPages' }),
						_react2['default'].createElement(
							_reactPagify2['default'].Button,
							{ className: styles['PaginationLinks--next'], page: articles.page + 1 },
							'»'
						)
					)
				)
			)
		);
	};

	_createClass(MoreNews, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			articlesError: _react.PropTypes.object,
			articlesLoading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			params: _react.PropTypes.object,
			routeParams: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _MoreNews = MoreNews;
	MoreNews = _reactRedux.connect(function (state) {
		return {
			articles: state.moreNews.data,
			articlesError: state.moreNews.error,
			articlesLoading: state.moreNews.loading
		};
	})(MoreNews) || MoreNews;
	MoreNews = _helpersConnectData2['default'](null, fetchDataDeferred)(MoreNews) || MoreNews;
	return MoreNews;
})(_react.Component);

exports['default'] = MoreNews;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MoreNews/MoreNews.js
 ** module id = 705
 ** module chunks = 0
 **/